import UserModalView from './UserModalViewContainer';
export default UserModalView;
